import { createAction, handleActions } from 'redux-actions';

export const types = {
  spectreappApplicationStart: 'SPECTREAPP_APPLICATION_START',
  spectreappSetUserSession: 'SPECTREAPP_SET_USER_INFORMATION',
  spectreappGetLastCustomerInfo: 'SPECTREAPP_GET_LAST_CUSTOMER_INFO',
  spectreappSetLastCustomerInfo: 'SPECTREAPP_SET_LAST_CUSTOMER_INFO',
  spectreappLoginUser: 'SPECTREAPP_LOGIN_USER',
  spectreappStartDatabase: 'SPECTREAPP_START_DATABASE',
  spectreappStartConnected: 'SPECTREAPP_DATABASE_CONNECTED',
  spectreappReady: 'SPECTREAPP_READY',
  spectreappCurrentPage: 'SPECTREAPP_CURRENTPAGE',
  spectreappGetImageDirectory: 'SPECTREAPP_GET_IMAGEDIRECTORY',
  spectreappSetImageDirectory: 'SPECTREAPP_SET_IMAGEDIRECTORY',
  spectreappSetIsDesktop: 'SPECTREAPP_SET_ISDESKTOP',
  spectreappDatabaseSync: 'SPECTREAPP_DATABASE_SYNC',
  spectreappDatabaseSynced: 'SPECTREAPP_DATABASE_SYNCED',
  deviceUnsubscribe: 'DEVICE_UNSUBSCRIBE',
  deviceUnsubscribed: 'DEVICE_UNSUBSCRIBED',
};

import { now } from '../../utils';

export const spectreappApplicationStart = createAction(types.spectreappApplicationStart);

export const spectreappSetUserSession = createAction(types.spectreappSetUserSession);

export const spectreappGetLastCustomerInfo = createAction(types.spectreappGetLastCustomerInfo);

export const spectreappSetLastCustomerInfo = createAction(types.spectreappSetLastCustomerInfo);

export const spectreappLoginUser = createAction(types.spectreappLoginUser);

export const spectreappStartDatabase = createAction(types.spectreappStartDatabase);

export const spectreappStartConnected = createAction(types.spectreappStartConnected);

export const spectreappCurrentPage = createAction(types.spectreappCurrentPage);

export const spectreappReady = createAction(types.spectreappReady);

export const spectreappGetImageDirectory = createAction(types.spectreappGetImageDirectory);

export const spectreappSetImageDirectory = createAction(types.spectreappSetImageDirectory);

export const spectreappSetIsDesktop = createAction(types.spectreappSetIsDesktop);

export const spectreappDatabaseSync = createAction(types.spectreappDatabaseSync);

export const spectreappDatabaseSynced = createAction(types.spectreappDatabaseSynced);

export const deviceUnsubscribe = createAction(types.deviceUnsubscribe);

export const deviceUnsubscribed = createAction(types.deviceUnsubscribed);

export const INITIAL_STATE = {
  userSession: {},
  ready: false,
  currentPage: 'bowlers',
  databaseConnected: false,
  databaseName: '',
  lastCustomerInfo: {},
  imageDirectory: '',
  isDesktop: false,
  platform: '',
  deviceInfo: null,
  databaseSyncing: false,
  subscriptionStatus: 'NO_INFO',
};

export const spectreAppReducer = handleActions(
  {
    [types.spectreappApplicationStart]: state => ({
      ...state,
      ready: false,
    }),
    [types.spectreappReady]: state => ({
      ...state,
      ready: true,
    }),
    [types.spectreappSetUserSession]: (state, action) => ({
      ...state,
      userSession: action.payload.userSession,
      sessionId: action.payload.sessionId,
      deviceInfo: action.payload.deviceInfo,
      subscriptionStatus: action.payload.subscriptionStatus,
    }),
    [types.spectreappLoginUser]: (state, action) => ({
      ...state,
      userSession: {
        ...state.userSession,
        rememberMe: action.payload.rememberMe,
        loginSince: now(),
        last_user: {
          ...state.userSession.last_user,
          loginSince: now(),
        },
      },
    }),
    [types.spectreappStartDatabase]: state => ({
      ...state,
      databaseConnected: false,
      databaseName: '',
    }),
    [types.spectreappStartConnected]: (state, action) => ({
      ...state,
      databaseConnected: true,
      databaseName: action.payload.databaseName,
    }),
    [types.spectreappCurrentPage]: (state, action) => ({
      ...state,
      currentPage: action.payload.currentPage,
    }),
    [types.spectreappSetLastCustomerInfo]: (state, action) => ({
      ...state,
      lastCustomerInfo: action.payload.lastCustomerInfo,
    }),
    [types.spectreappSetImageDirectory]: (state, action) => ({
      ...state,
      imageDirectory: action.payload.imageDirectory,
    }),
    [types.spectreappSetIsDesktop]: (state, action) => ({
      ...state,
      isDesktop: action.payload.isDesktop,
      platform: action.payload.platform,
    }),
    [types.spectreappDatabaseSync]: state => ({
      ...state,
      databaseSyncing: true,
    }),
    [types.spectreappDatabaseSynced]: state => ({
      ...state,
      databaseSyncing: false,
    }),
    [types.deviceUnsubscribed]: (state, action) => ({
      ...state,
      userSession: action.payload.userSession,
      sessionId: action.payload.sessionId,
      deviceInfo: null,
    }),
  },
  INITIAL_STATE
);
